import { render, staticRenderFns } from "./information-text.vue?vue&type=template&id=3f218381&scoped=true"
import script from "./information-text.vue?vue&type=script&lang=js"
export * from "./information-text.vue?vue&type=script&lang=js"
import style0 from "./information-text.vue?vue&type=style&index=0&id=3f218381&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f218381",
  null
  
)

export default component.exports